import script from "./PageDescription.vue?vue&type=script&lang=ts&setup=true"
export * from "./PageDescription.vue?vue&type=script&lang=ts&setup=true"

import "./PageDescription.vue?vue&type=style&index=0&id=3d43821c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d43821c"]])

export default __exports__